import templateStr from 'text!./templates/document-upload.html';

export default ['$document', 'httpSettings', 'maxFileUploadSize', 'oAuth', '$log', 'FileUploadUtil', '$filter', function ($document, httpSettings, maxFileUploadSize, oAuth, $log, FileUploadUtil, $filter) {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            metadataTemplate: '&metadata',
            documents: '=',
            disableAutoUpload: '@disableAutoUpload',
            dropZoneSelector: '&',
            customClass: '='
        },
        link: function link(scope) {
            scope.sessionToken = 'dl';
            scope.serviceName = 'driverlicense';
            scope.isDriverLicenseUpload = true;
            scope.buttonText = $filter('translate')('platform.documentupload.templates.document-upload.Scan driver license barcode');
            scope.allowedFilesTypes = '.png,.jpg';
            scope.tooltipText = scope.buttonText;
            var dropZoneElement = FileUploadUtil.createDropZoneElement(scope.dropZoneSelector(), $document);
            scope.options = FileUploadUtil.createOptions(httpSettings.serviceBaseURLs.pc + scope.serviceName, !scope.disableAutoUpload, maxFileUploadSize, dropZoneElement);

            FileUploadUtil.addAuthTokenHeader(scope.options, oAuth).then(function (options) {
                options.dropZone = dropZoneElement;
                scope.options = options;
            });

            scope.metadata = [];
            var newDocuments = [];
            var errorUploading = false;

            scope._unbind = function (eventname) {
                if (eventname in scope._unbind.handlers) {
                    scope._unbind.handlers[eventname]();
                }
            };
            scope._unbind.handlers = {};

            var bind = function bind(eventname, cb) {
                scope._unbind.handlers[eventname] = scope.$on(eventname, cb);
            };

            bind('fileuploadadd', function (e, data) {
                data.files[0].metadata = FileUploadUtil.createDocMetadata(scope.metadataTemplate(), data, scope.sessionToken);
            });

            bind('fileuploadsubmit', function (e, data) {
                data.formData = {
                    document: JSON.stringify(data.files[0].metadata)
                };
            });

            bind('fileuploaddone', function (e, data) {
                newDocuments.push(data.result.result);
                e.targetScope.clear(data.files);
            });

            /**
             * Add the temporarily held documents in newDocuments to the documents array.
             * We reset the newDocuments array back to zero after we have added it to the documents array.
             * We do this because old references to previously added documents may remain, and
             * an exception will be thrown if you try to add the same document twice.
             */
            bind('fileuploadstop', function () {
                var result = FileUploadUtil.handleFileUploadStop(scope.documents, newDocuments, errorUploading, true);
                scope.documents = result.documents;
                newDocuments = result.newDocuments;
                errorUploading = result.errorUploading;
            });

            bind('fileuploadfail', function () {
                errorUploading = true;
                $log.error('platform.documentupload.DocumentUploadDirective.Unable to scan the driver license barcode. Please make sure that the image you have uploaded displays a barcode.');
            });

            bind('fileuploadprocessfail', function () {
                errorUploading = true;
                $log.error('platform.documentupload.DocumentUploadDirective.Processing file failed.');
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/documentupload/DriverLicenseUploadDirective.js
// module id = 1108
// module chunks = 0